/**
 * Per-contract signing-mode resolution (per ADR-0061).
 *
 * Signing mode is normally a static `metadata.signingMode`. The "clean
 * tilläggsavtal" frame instead lets the user choose whether the document is
 * signed: with `metadata.signingOptional`, the effective mode is resolved
 * from `values.include_signing` — falsy ⇒ `export_only` (no signing block,
 * export-and-mark-sent), otherwise the declared `signingMode` (default
 * `scrive`). Every consumer that branches on signing behaviour resolves
 * through this helper instead of reading `metadata.signingMode` directly.
 */
/** Reserved `values` key carrying the optional-signing toggle. */
export const INCLUDE_SIGNING_KEY = 'include_signing';
export function effectiveSigningMode(metadata, values) {
    const base = metadata.signingMode ?? 'scrive';
    if (!metadata.signingOptional)
        return base;
    // Default ON: only an explicit `false` turns the document into export-only.
    return values?.[INCLUDE_SIGNING_KEY] === false ? 'export_only' : base;
}
//# sourceMappingURL=signing-mode.js.map